import api from "./axios";
import type { LogislyDriver, LogislyLocation, LogislyTruck } from "../types/logislyOrderTaker";
import type { PaginationParam, PaginationResponse } from "../types/paginationResponse";
import { mapPaginationResponse } from "../types/paginationResponse";
import { buildPaginationQuery } from "../utils/pagination";

export interface LogislyCatalogResponse<T> {
  items: T[];
  pagination: PaginationResponse;
}

const allQuery = (all?: boolean) => (all ? "?all=true" : "");

export const getLogislyTrucksApi = async (all = false): Promise<LogislyTruck[]> => {
  const response = await api.get(`/api/v1/logisly/trucks${allQuery(all)}`);
  return response.data.data.trucks;
};

export const searchLogislyTrucksApi = async (
  pagination?: PaginationParam,
): Promise<LogislyCatalogResponse<LogislyTruck>> => {
  const response = await api.get(`/api/v1/logisly/trucks${buildPaginationQuery(pagination)}`);
  return {
    items: response.data.data.trucks,
    pagination: mapPaginationResponse(response.data.data.pagination),
  };
};

export const getLogislyDriversApi = async (all = false): Promise<LogislyDriver[]> => {
  const response = await api.get(`/api/v1/logisly/drivers${allQuery(all)}`);
  return response.data.data.drivers;
};

export const searchLogislyDriversApi = async (
  pagination?: PaginationParam,
): Promise<LogislyCatalogResponse<LogislyDriver>> => {
  const response = await api.get(`/api/v1/logisly/drivers${buildPaginationQuery(pagination)}`);
  return {
    items: response.data.data.drivers,
    pagination: mapPaginationResponse(response.data.data.pagination),
  };
};

export const getLogislyLocationsApi = async (all = false): Promise<LogislyLocation[]> => {
  const response = await api.get(`/api/v1/logisly/locations${allQuery(all)}`);
  return response.data.data.locations;
};

export const searchLogislyLocationsApi = async (
  pagination?: PaginationParam,
): Promise<LogislyCatalogResponse<LogislyLocation>> => {
  const response = await api.get(`/api/v1/logisly/locations${buildPaginationQuery(pagination)}`);
  return {
    items: response.data.data.locations,
    pagination: mapPaginationResponse(response.data.data.pagination),
  };
};

export const linkLogislyTruckApi = async (id: string, localTruckId: string) => {
  const response = await api.post(`/api/v1/logisly/trucks/${id}/link`, { localTruckId });
  return response.data.data.truck;
};

export const linkLogislyDriverApi = async (id: string, localUserId: string) => {
  const response = await api.post(`/api/v1/logisly/drivers/${id}/link`, { localUserId });
  return response.data.data.driver;
};

export const linkLogislyLocationApi = async (id: string, localCityId: string) => {
  const response = await api.post(`/api/v1/logisly/locations/${id}/link`, { localCityId });
  return response.data.data.location;
};
